import * as React from "react";
import { Modal, Form, ModalBody, HiddenInput, Textarea, TextInput, ModalFooter, ModalSize, CustomButton, ButtonType, CustomSubmitButton } from "soprasteria-ui-library";
import { dateTimeToDateString } from "../../../../helpers/DateHelper";
import { IPatientInternalNote } from "../../../../models/IPatientInternalNote";
import { PatientInternalNoteApi } from "../../../../api/PatientInternalNoteApi";
import { useAuth } from "../../../../App";
import { setMessage } from "../../../../helpers/MessageHelper";

interface IInternalNotesTabEditModal {
    onSubmitSuccess: () => void;
    noteToEdit?: IPatientInternalNote;
    onCloseModal: () => void;
    patientId: number;
}

export const InternalNotesTabEditModal: React.FunctionComponent<IInternalNotesTabEditModal> = ({ onSubmitSuccess, patientId, noteToEdit, onCloseModal }) => {

    const auth = useAuth();
    const api = new PatientInternalNoteApi(auth);

    const [isSubmitting, setIsSubmitting] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>("");

    React.useEffect(() => {
        document.getElementById("open-internal-note-modal")?.click();
    }, [])

    const submitNote = (note: IPatientInternalNote) => {
        setIsSubmitting(true);

        note.patientId = patientId;
        api.savePatientInternalNote(note, () => {
            document.getElementById("close-internal-note-modal")?.click();
            onSubmitSuccess();
        }, (message) => {
            const newErrorMessage = setMessage(message, errorMessage);
            setErrorMessage(newErrorMessage);
            setIsSubmitting(false);
        });
    }
    
    return (
        <Modal id="internal-note-modal" header={noteToEdit ? "Redigera TVE-notering" : "Skapa TVE-notering"} modalSize={ModalSize.large}>
            <Form onSubmit={submitNote} >
                <ModalBody>
                    <Textarea label="Notering" name="note" defaultValue={noteToEdit?.note} maxLength={1000} rows={6} inlineLabel />
                    {
                        noteToEdit ?
                            <>
                                <TextInput label="Skapad av" name="noteBy" defaultValue={noteToEdit?.noteBy} readonly inlineLabel />
                                <TextInput label="Skapad datum" name="noteDate" defaultValue={dateTimeToDateString(noteToEdit?.noteDate)} readonly inlineLabel />
                                <TextInput label="Uppdaterad av" name="noteUpdatedBy" defaultValue={noteToEdit?.noteUpdatedBy} readonly inlineLabel />
                                <TextInput label="Uppdaterad datum" name="noteUpdatedDate" defaultValue={dateTimeToDateString(noteToEdit?.noteUpdatedDate)} readonly inlineLabel />
                                <HiddenInput name="patientNoteId" value={noteToEdit ? noteToEdit.patientNoteId!.toString() : ""} />
                            </>
                            : null
                    }
                </ModalBody>
                <ModalFooter>
                    <div className="text-right btn-group" role="group">
                        <CustomButton
                            buttonType={ButtonType.general}
                            buttonText="Avbryt"
                            data-dismiss="modal"
                            id="close-internal-note-modal"
                            onClick={() => onCloseModal()} />
                        <CustomSubmitButton isLoading={isSubmitting}>Spara</CustomSubmitButton>
                    </div>
                    <input type="hidden" data-toggle="modal" id="open-internal-note-modal" data-target="#internal-note-modal" />
                </ModalFooter>
            </Form>
        </Modal>
    );
}